import type {GetRemindersResponse} from '../../../core/repositories/mypageEntryManagementsRepository';

export type ReminderText = {
  deadlineText?: string;
  eventText?: string;
};

/**
 * リマインダーAPIのレスポンスから表示用のテキストを生成する
 * 締切と開催を分けて表示し、混在している場合は合計件数を表示する
 */
export const generateReminderText = (
  data: GetRemindersResponse,
): ReminderText => {
  const {
    deadlineWithinThreeDays,
    deadlineWithinDay,
    startDateWithinWeek,
    startDateWithinDay,
  } = data;

  const result: ReminderText = {};

  // 締切のテキスト生成
  // 3日以内と1日以内が混在している場合は、3日以内の件数を表示
  if (deadlineWithinThreeDays > 0 || deadlineWithinDay > 0) {
    const count = deadlineWithinThreeDays || deadlineWithinDay;
    result.deadlineText = `締め切り間近の予定が${count}件あります`;
  }

  // 開催のテキスト生成
  // 1週間以内と1日以内が混在している場合は、1週間以内の件数を表示
  if (startDateWithinWeek > 0 || startDateWithinDay > 0) {
    const count = startDateWithinWeek || startDateWithinDay;
    result.eventText = `開催間近の予定が${count}件あります`;
  }

  return result;
};
